import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute, DomainRedirect } from '../utils/domain/routingComponents'
import { enterpriseSolutionsAccessControl } from '../access-control/enterpriseSolutionsAccess.configuration'

const EnterpriseStatusPage = lazy(
  () => import('../tools/enterprise-status-page/pages/EnterpriseStatusPage')
)

export const enterpriseSolutionsAdminRouter = (
  <DomainRoute
    route="app-admin-enterprise-status-page"
    accessControl={enterpriseSolutionsAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-enterprise-status-page"
        component={EnterpriseStatusPage}
      />
      <DomainRedirect toRoute="app-admin-enterprise-status-page" />
    </DashSwitch>
  </DomainRoute>
)
